module.exports = __webpack_public_path__ + "static/img/5.2e8dcbd9.png";